import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { User } from '../../model/UserModel';
import { CronosActionPage } from '../cronos-action/cronos-action';

@IonicPage()
@Component({
  selector: 'page-cronos-popover',
  templateUrl: 'cronos-popover.html',
})
export class CronosPopoverPage {

  public member: string;
  public users: Array<User>;

  private previousPage: CronosActionPage;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public viewCtrl: ViewController
  ) {
  }

  ionViewDidLoad() {
    if (this.navParams.data) {
      this.users = this.navParams.data.users;
      this.previousPage = this.navParams.data.page;
    }
  }

  selectMember() {
    if (this.member != null) {
      if (this.previousPage.comment == null) {
        this.previousPage.comment = '';
      }
      this.previousPage.comment += '(' + this.member + ')';
      this.viewCtrl.dismiss();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-popover/cronos-popover.ts